import React from 'react';

import ChatMessage from './ChatMessage';

import CliveAvatar from '~/core/iconComponents/special/CliveAvatar';

interface CliveChatMessageProps {
  message: React.ReactNode;
  createdAt?: Date;
  className?: string;
  claimNumber?: string;
  isLoading?: boolean;
  withTypingEffect?: boolean;
  onEndTypingEffect?: () => void;
  documentsUsed?: string[]; // Array of resolved document metadata
  messagePrefix?: React.ReactNode;
}

const CliveChatMessage: React.FC<CliveChatMessageProps> = ({
  message,
  className,
  isLoading,
  withTypingEffect = false,
  onEndTypingEffect,
  documentsUsed,
  claimNumber,
  messagePrefix,
}) => {
  return (
    <ChatMessage
      message={message}
      sender="Clive"
      senderRole="AI assistant"
      avatar={<CliveAvatar />}
      isLoading={isLoading}
      className={className}
      withTypingEffect={withTypingEffect}
      onEndTypingEffect={onEndTypingEffect}
      documentsUsed={documentsUsed}
      isReferenceTags
      claimNumber={claimNumber}
      messagePrefix={messagePrefix}
    />
  );
};

export default CliveChatMessage;
